export function reorderArray(
  array: any[],
  indexes: { from: number; to: number }
) {
  var element = array[indexes.from];
  array.splice(indexes.from, 1);
  array.splice(indexes.to, 0, element);
  return array;
}
